import { xMaxValue, xAdd, createRandomArray } from 'ml-spectra-processing';
export default function addNoise(data, options = {}) {
    const { seed = 0, distribution = 'normal', percent = 1 } = options;
    const range = (xMaxValue(data.y) * percent) / 100;
    const noise = createRandomArray({
        distribution,
        seed,
        mean: 0,
        standardDeviation: range,
        range,
        length: data.x.length,
    });
    data.y = xAdd(data.y, noise);
    return data;
}
//# sourceMappingURL=addNoise.js.map